









































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import ConversationData from '@/ts/ConversationData';
import PersonData from '@/ts/PersonData';
import { mapGetters } from 'vuex';
import PersonSuggestions from '@/components/PersonSuggestions.vue';
import MessageMethods from '@/mixins/MessageMethods.vue';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';
import Participants from '@/components/Messages/Participants.vue';

@Component({
    computed: {
        ...mapGetters({
            visibleConversationsStatus: 'Messages/getVisibleConversationsStatus',
            suggestedStuffUsers: 'Messages/getSuggestedStuffUsers',
        }),
    },
    components: {
        PersonSuggestions,
        BaseDropDown,
        Participants,
    },
})
export default class Header extends Mixins(MessageMethods) {
    @Prop() public conversation!: ConversationData;

    public searchQuery: string = '';
    public suggestedStuffQuery: string = '';
    public showConversationMembersDropDown: boolean = false;

    constructor() {
        super();
    }

    get currentUserImage() {
        if (!this.currentUser.fetchedMiniature) {
            this.currentUser.fetchMiniature(this.$store);
            this.currentUser.fetchedMiniature = true;
        }

        if (this.currentUser.hasMiniature || this.currentUser.hasProfileImage) {
            if (this.currentUser.hasMiniature) {
                return this.currentUser.miniatureImage;
            }

            if (this.currentUser.hasProfileImage) {
                return this.currentUser.profileImage;
            }
        }

        return null;
    }

    get firstInitial() {
        if (!this.conversation) {
            return '';
        }

        return this.conversation.firstInitial;
    }

    get currentUser() {
        return this.$store.getters['User/getUser'];
    }

    get getUserId() {
        return this.$store.getters['User/getUserId'];
    }

    get participants(): number[] {
        return this.conversation.participants;
    }

    get dataLoaded(): boolean {
        return (
            this.conversation !== null
         && this.conversation.participants !== null
         && this.conversation.messages !== null
         );
    }

    @Watch('showConversationMembersDropDown')
    public showConversationMembersDropDownChange() {
        if (!this.showConversationMembersDropDown) {
            this.$store.commit(Mutations.SET_SUGGESTED_STUFF_USERS, []);
            this.suggestedStuffQuery = '';
        }
    }

    public getSuggestedStuffUsers(): void {
        if (this.suggestedStuffQuery.trim().length > 1) {
            this.$store.dispatch(Actions.FETCH_SUGGESTED_STUFF_USERS, {search: this.suggestedStuffQuery, conversationId: this.conversation.id});
        } else {
            this.$store.commit(Mutations.SET_SUGGESTED_STUFF_USERS, []);
        }
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }

    public toggelForConversation(participantId: number, action: string) {
         this.$store.dispatch(Actions.TOGGLE_PERSON_FOR_CONVERSATION, {participantId, conversationId: this.conversation.id, action});
    }

    public participantImage(id: any) {
        const participant =  this.$store.getters['User/getCacheUser'](id);

        if (typeof participant === 'undefined') {
            return null;
        }

        if (!participant.fetchedMiniature) {
            participant.fetchMiniature(this.$store);
            participant.fetchedMiniature = true;
        }

        if (participant.hasMiniature || participant.hasProfileImage) {
            if (participant.hasMiniature) {
                return participant.miniatureImage;
            }

            if (participant.hasProfileImage) {
                return participant.profileImage;
            }
        }

        return null;
    }

    public participantData(id: number, key: any) {
        const participant: any =  this.$store.getters['User/getCacheUser'](id);

        if (key === 'fullName') {
            return `${participant.firstName} ${participant.familyName}`;
        } else if (key === 'firstInitial') {
            return  participant.firstName.charAt(0);
        } else if (key === 'role') {
            return participant.roleData ? participant.roleData.name : '';
        }
        return participant[key];
    }

    public changeConversationStatus(status: string) {
        this.$store.dispatch(Actions.CHANGE_CONVERSATION_STATUS, {status , conversationId: this.activeConversation.id, type: 'admin'});
    }

    get senderImage() {
        if (this.sender.fetchedMiniature === false) {
            this.sender.fetchMiniature(this.$store);
            this.sender.fetchedMiniature = true;
        }

        if (this.sender !== null && typeof this.sender !== 'undefined') {
            if (this.sender.hasMiniature || this.sender.hasProfileImage) {

                if (this.sender.hasMiniature) {
                    return this.sender.miniatureImage;
                }

                if (this.sender.hasProfileImage) {
                    return this.sender.profileImage;
                }
            }
        }

        return null;
    }

    get sender() {
        return this.$store.getters['User/getCacheUser'](this.activeConversation.authorId);
    }
}
